/**
 * Isolate the context in an IIFE
 *
 * @param object $ jQuery object
 * @param object Drupal Drupal object
 * @param window window Current window object
 * @param document document Current document object
 */

(function ($, Drupal, window/* , document */) {
  const $window = $(window);
  /**
   * Main script for the current theme
   */
  Drupal.behaviors.themeJS = {
    /**
     * Trigger this function when the pages and Drupal js core was loaded
     *
     * @param object context Dom element triggered this method
     * @param object settings Curent Drupal settings
     *
     */
    attach (context/* , settings */) {
      /* Show and hide header on scrolling. */
      const SCROLL_THRESHOLD = 200;
      const CLASS_SCROLLED = 'js-did-scroll';

      const $body = $('body', context);

      $window.on('scroll', () => {
        const offsetTop = $window.scrollTop();
        const didPassThreshold = offsetTop > SCROLL_THRESHOLD;

        if (didPassThreshold && !$body.hasClass(CLASS_SCROLLED)) {
          $body.addClass(CLASS_SCROLLED);
        } else if (!didPassThreshold && $body.hasClass(CLASS_SCROLLED)) {
          $body.removeClass(CLASS_SCROLLED);
        }
      });
    },
  };

  Drupal.behaviors.resetPaginationOnFilter = {
    attach () {
      // Listen for AJAX submissions of Views
      $(document).ajaxSend((event, xhr, settings) => {
        if (settings.url.includes('views/ajax')) {
          const url = new URL(settings.url, window.location.origin);
          const params = new URLSearchParams(url.search);

          // Reset the page parameter to 0
          params.set('page', '0');

          // Update the AJAX request URL
          settings.url = `${url.pathname}?${params.toString()}`;
        }
      });
    },
  };

  // This behavior is used to remove the active filter for the field "keys"
  // in the school search page.
  Drupal.behaviors.activeFilterCustomRemove = {
    attach: (context) => {
      const inputs = once('remove', '[name=keys]', context);
      inputs.forEach((input) => {
        input.activeFilterRemove = () => {
          // We have to also empty the field input[name="keys"][type="text"] related to
          // the filter field (which is a field input[name="keys"][type="search"])
          const textInput = document.querySelector('input[name="keys"][type="text"]');
          textInput.setAttribute('value', '');
        };
      });
    },
  };

  Drupal.behaviors.curlyLineBackground = {
    attach (context) {
      const curlyLines = context.querySelectorAll('.curly-line');

      curlyLines.forEach((curlyLine) => {
        const { position } = curlyLine.dataset;
        const parent = curlyLine.parentElement;

        // Get the previous our next section
        let previousOrNextSection = null;
        if (position === 'top') {
          previousOrNextSection = parent.previousElementSibling;
        } else if (position === 'bottom') {
          previousOrNextSection = parent.nextElementSibling;
        }

        // If we have a previous or next section, apply its background color
        if (previousOrNextSection) {
          const bgColor = window.getComputedStyle(previousOrNextSection).backgroundColor;
          if (bgColor === 'rgba(0, 0, 0, 0)') {
            curlyLine.style.backgroundColor = '#FFFFFF';
          } else {
            curlyLine.style.backgroundColor = bgColor;
          }
        }
      });
    },
  };

  Drupal.behaviors.heroBannerBottomCurlyLineBackground = {
    attach (context) {
      const curlyLines = context.querySelectorAll('.hero-banner-fullscreen-video-curly-line');

      curlyLines.forEach((curlyLine) => {
        const parent = curlyLine.parentElement;

        // Get the next section
        const nextSection = parent.nextElementSibling;

        // If we have a next section, apply its background color
        if (nextSection) {
          let bgColor = window.getComputedStyle(nextSection).backgroundColor;
          if (!bgColor || bgColor === 'rgba(0, 0, 0, 0)') {
            // If no background color or transparent, set to white
            bgColor = '#ffffff';
          }

          const svg = curlyLine.querySelector('svg');
          if (svg) {
            const paths = svg.querySelectorAll('path');
            if (paths.length > 1) {
              paths[1].setAttribute('fill', bgColor);
            }
          }
        }
      });
    },
  };
}(jQuery, Drupal, window, document));
